import { Action, Reducer } from 'redux';
import * as Actions from '../actions';
import * as ActionEvents from '../actions/Snomed.Actions';
import { SnomedState, SnomedUnloadState } from '../states/Snomed.State';

export type KnownAction =
    | Actions.Snomed.SnomedSearchRequestAction
    | Actions.Snomed.SnomedSearchSuccessAction
    | Actions.Snomed.SnomedSearchFailureAction
    | Actions.Snomed.SnomedSearchClearAction;

export const SnomedReducer: Reducer<SnomedState> = (
    state: SnomedState | undefined,
    incomingAction: Action
): SnomedState => {
    if (state === undefined) {
        return SnomedUnloadState as SnomedState;
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case ActionEvents.SNOMED_SEARCH_REQUEST:
            return {
                ...state,
                isSearching: true,
                searchTerm: action.searchTerm,
                error: undefined
            };
        case ActionEvents.SNOMED_SEARCH_SUCCESS:
            return {
                ...state,
                isSearching: false,
                searchResults: action.payload,
                searchTerm: action.searchTerm,
                error: undefined
            };
        case ActionEvents.SNOMED_SEARCH_FAILURE:
            return {
                ...state,
                isSearching: false,
                searchResults: [],
                error: action.error
            };
        case ActionEvents.SNOMED_SEARCH_CLEAR:
            return {
                ...SnomedUnloadState
            };
        default:
            return state;
    }
};
